"use client";

import { ReactNode } from "react";
import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import { PageParams } from "@/app/types/common/DefaultProps";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./NextStepCard.module.css";

type Props = {
  params: PageParams;
  icon: ReactNode;
  title: string;
  description: string;
  ctaLabel: string;
  href?: string;
  onClick?: () => void;
  className?: string;
};

export default function NextStepCard(props: Props) {
  const { params, icon, title, description, ctaLabel, href, onClick, className } = props;

  return (
    <div className={UStyles.classNames(styles.container, className)}>
      <div className={styles.header}>
        <div className={styles.icon}>{icon}</div>
        <h4 className={styles.title}>{title}</h4>
      </div>

      <p className={styles.desc}>{description}</p>

      <Button
        params={params}
        text={`${ctaLabel} →`}
        href={href}
        onClick={onClick}
        type={ButtonType.PRIMARY}
        className={styles.cta}
        min={true}
        isLink={!!href}
      />
    </div>
  );
}
